import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBack = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18.6667 18.6667",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.1583 1.99162C10.6139 1.53601 10.6139 0.79732 10.1583 0.341709C9.70268 -0.113903 8.96399 -0.113903 8.50838 0.341709L0.341709 8.50838C-0.113903 8.96399 -0.113903 9.70268 0.341709 10.1583L8.50838 18.325C8.96399 18.7806 9.70268 18.7806 10.1583 18.325C10.6139 17.8693 10.6139 17.1307 10.1583 16.675L3.98325 10.5L17.5 10.5C18.1443 10.5 18.6667 9.97767 18.6667 9.33334C18.6667 8.689 18.1443 8.16667 17.5 8.16667L3.98325 8.16667L10.1583 1.99162Z",
		fill: "currentColor"
	})
});
export default SvgBack;
